import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';

const ContactForm = () => {

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section id="contact" className="py-20 relative">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-center"
        >
          {/* Section Header */}
          <motion.div variants={itemVariants} className="mb-12">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
              Contact <span className="text-gradient">Information</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Ready to transform your business with AI automation? 
              Reach out to us for expert consulting services.
            </p>
          </motion.div>

          

          {/* Contact Information */}
          <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <motion.div 
              className="bg-glass-effect rounded-2xl p-8 border border-gray-700/50 card-3d depth-shadow"
              whileHover={{ 
                rotateX: 5,
                rotateY: 5,
                scale: 1.02,
                transition: { duration: 0.3 }
              }}
            >
              <h3 className="text-xl font-semibold text-white mb-4">Contact Us</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-primary-400" />
                  <a 
                    href="mailto:hello@vaza.ai" 
                    className="text-gray-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    hello@vaza.ai
                  </a>
                </div>
                <p className="text-gray-400 text-sm">
                  Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
                </p>
              </div>
            </motion.div>

            <motion.div 
              className="bg-glass-effect rounded-2xl p-8 border border-gray-700/50 card-3d depth-shadow"
              whileHover={{ 
                rotateX: 5,
                rotateY: 5,
                scale: 1.02,
                transition: { duration: 0.3 }
              }}
            >
               <h3 className="text-xl font-semibold text-white mb-4">Consulting Process</h3>
               <div className="space-y-4">
                 <p className="text-gray-400 text-sm">
                   Our proven consulting process includes assessment, planning, implementation, and ongoing support to ensure your automation success.
                 </p>
                 <div className="flex space-x-4">
                   <div className="w-2 h-2 bg-primary-500 rounded-full"></div>
                   <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                   <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                 </div>
               </div>
             </motion.div>
          </motion.div>

          {/* Additional Info */}
          <motion.div variants={itemVariants} className="mt-12 text-center">
                         <p className="text-gray-400 text-sm">
               By contacting us, you agree to our{' '}
               <a href="/privacy" className="text-primary-400 hover:text-primary-300 transition-colors duration-200">
                 Privacy Policy
               </a>{' '}
               and{' '}
               <a href="/terms" className="text-primary-400 hover:text-primary-300 transition-colors duration-200">
                 Terms of Service
               </a>
             </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactForm; 